import { callAuthorizedGraphQLEndpoint } from '../../../../../../Module/graphQL'

const getPromoCampaigns = async ({ cityId: id }) => {
  const query = `query ($id:ID!) {
        city(id: $id){
            country{
                currencySign
            }
            promoCampaigns{
                nodes{
                    id
                    missionsTrigger
                    missionsCompleted
                    bonusAmount
                    amountSpent
                    promoCode
                    signUpLimit
                    isActive
                    createdAt
                    updatedAt
                    promoBatchId
                    signUps
                }
            }
          }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    id,
  })
}

const createPromoCampaign = async input => {
  const query = `mutation ($input: CreatePromoCampaignInput!) {
  createPromoCampaign(input: $input){
        id
        cityId
        missionsTrigger
        bonusAmount
        promoCode
        signUpLimit
        isActive
        createdAt
        updatedAt
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const updatePromoCampaign = async input => {
  const query = `mutation ($input: UpdatePromoCampaignInput!) {
    updatePromoCampaign(input: $input){
      id
      isActive
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export { getPromoCampaigns, createPromoCampaign, updatePromoCampaign }
